import React from 'react';
import './styes/FooterPages.css';

const Support: React.FC = () => {
  return (
    <div className="footer-page">
      <h1>Support</h1>
      <p>We're here to help! If you have any questions or need assistance, please don't hesitate to reach out to us.</p>
      
      <div className="support-section">
        <h2>Get in Touch</h2>
        
        <div className="support-item">
          <h3>Email</h3>
          <p>
            <a href="mailto:support@buildzap.in">support@buildzap.in</a>
          </p>
          <p className="support-description">For general inquiries and support</p>
        </div>

        <div className="support-item">
          <h3>Phone</h3>
          <p>
            <a href="tel:+917617610660">+91 7617610660</a>
          </p>
          <p className="support-description">Available Monday to Friday, 9 AM to 9 PM IST</p>
        </div>

        <div className="support-item">
          <h3>Customer Service</h3>
          <p>Response time: Within 24 hours</p>
          <p className="support-description">We strive to resolve all inquiries promptly and efficiently.</p>
        </div>
      </div>
    </div>
  );
};

export default Support;
